export const COMMENTS_NO_COMMENTS = 'comments.no-comments';
